import { Route, Routes } from "react-router-dom";

import K2Portfolios from "./K2Portfolios/main";
import K2StaticData from "./K2StaticData/main";
import K2TimeSeries from "./K2TimeSeries/main";
import K2Transactions from "./K2Transactions/main";
import K2DataUpload from "./K2DataUpload/main";
import K2Issuers from "./K2Issuers/main";
import K2PdfPageSelection from "./K2PdfPageSelection/main";
import K2DownloadCenter from "./K2DownloadCenter/main";

export default function K2Routes() {
  return (
    <Routes>
      <Route path="k2_portfolios/*" element={<K2Portfolios />} />
      <Route path="k2_static_data/*" element={<K2StaticData />} />
      <Route path="k2_time_series/*" element={<K2TimeSeries />} />
      <Route path="k2_transactions/*" element={<K2Transactions />} />
      <Route path="k2_data_upload/*" element={<K2DataUpload />} />
      <Route path="k2_pdf_page_selection/*" element={<K2PdfPageSelection />} />
      <Route path="k2_download_center/*" element={<K2DownloadCenter />} />
      <Route path="k2_issuers/*" element={<K2Issuers />} />
    </Routes>
  );
}
